import { render, staticRenderFns } from "./controlePerfilChefia.vue?vue&type=template&id=2580c5fe&"
import script from "./controlePerfilChefia.vue?vue&type=script&lang=js&"
export * from "./controlePerfilChefia.vue?vue&type=script&lang=js&"
import style0 from "./controlePerfilChefia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports